import type { WorkingViewDefinition } from '@/stores/workingViewStore';
import { isPropStat, type PropStat } from '@/lib/sport/propStat';
import type { Period, PriceMode } from '../ValueDashboard/types';

export interface GameLinesReading {
  priceMode: PriceMode;
  marketSide: 'yes' | 'no';
  betType: 'spread' | 'total' | 'moneyline' | 'btts' | 'race' | 'overtime';
  hideNoVol: boolean;
  hideSettled: boolean;
  period: Period;
  tab: 'lines' | 'props' | 'events';
  propStat: PropStat;
}
export const gameLinesReading: WorkingViewDefinition<GameLinesReading> = {
  id: 'game-lines-reading-v1',
  parse(input) {
    if (!input || typeof input !== 'object') return null;
    const v = input as Partial<GameLinesReading>;
    if (!['maker', 'taker', 'market'].includes(v.priceMode ?? '')
      || !['yes', 'no'].includes(v.marketSide ?? '')
      || !['spread', 'total', 'moneyline', 'btts', 'race', 'overtime'].includes(v.betType ?? '')
      || typeof v.hideNoVol !== 'boolean' || typeof v.hideSettled !== 'boolean'
      || !['full', '1H', '2H', 'F5', '1Q', '2Q', '3Q', '4Q'].includes(v.period ?? '')
      || !['lines', 'props', 'events'].includes(v.tab ?? '')
      || !v.propStat || !isPropStat(v.propStat)) return null;
    return { priceMode: v.priceMode!, marketSide: v.marketSide!, betType: v.betType!,
      hideNoVol: v.hideNoVol, hideSettled: v.hideSettled, period: v.period!, tab: v.tab!, propStat: v.propStat };
  },
};
export const spreadTotalReading: WorkingViewDefinition<Pick<GameLinesReading, 'priceMode' | 'marketSide'>> = {
  id: 'game-spread-total-reading-v1',
  parse(input) {
    if (!input || typeof input !== 'object') return null;
    const v = input as Partial<GameLinesReading>;
    return ['maker', 'taker', 'market'].includes(v.priceMode ?? '') && ['yes', 'no'].includes(v.marketSide ?? '')
      ? { priceMode: v.priceMode!, marketSide: v.marketSide! } : null;
  },
};
export const moneylineReading = { ...spreadTotalReading, id: 'game-moneyline-reading-v1' };
